// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSingleColumn_root__3cKhi","layoutWrapperMain":"LayoutSingleColumn_layoutWrapperMain__1wf6G"};